import { CALL_API } from '../middleware/api'

export const GAMES_REQUEST = 'GAMES_REQUEST'
export const GAMES_SUCCESS = 'GAMES_SUCCESS'
export const GAMES_FAILURE = 'GAMES_FAILURE'

export function fetchGameResults() {
  let params = ''

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `games?${params}`,
      authenticated: true,
      types: [GAMES_REQUEST, GAMES_SUCCESS, GAMES_FAILURE]
    }
  }
}
